import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { useId } from 'react';
import { Form } from 'react-bootstrap';
import { joinClasses } from 'utils/componentStyles/style.utils';

/** A labelled profile field using the selected Account appearance. */
const AccountField = ({
  label,
  value = '',
  onChange,
  canEdit = true,
  type = 'text',
  options,
  classic = false,
  className,
}) => {
  const controlId = useId();
  const selectOptions = options?.map((option) => ({ value: option, label: option }));

  return (
    <Form.Group controlId={controlId} className={joinClasses('user-menu-field', className)}>
      <Form.Label>{label}</Form.Label>
      {selectOptions ? (
        <BaseSelect
          inputId={controlId}
          isSearchable
          styles={
            classic
              ? {
                  control: (base) => ({
                    ...base,
                    background: canEdit ? 'var(--color-primary)' : 'var(--bs-secondary-color)',
                    color: canEdit ? 'var(--bs-body-color)' : 'var(--bs-secondary-color)',
                  }),
                }
              : undefined
          }
          selectProps={{
            options: selectOptions,
            value: findSelectOption(selectOptions, value),
            isDisabled: !canEdit,
            onChange: (option) => onChange?.(option?.value ?? ''),
          }}
        />
      ) : (
        <Form.Control
          style={
            classic
              ? { background: canEdit ? 'var(--color-primary-shadow)' : 'var(--bs-secondary)' }
              : undefined
          }
          value={value ?? ''}
          type={type}
          disabled={!canEdit}
          onChange={(event) => onChange?.(event.target.value)}
        />
      )}
    </Form.Group>
  );
};

export default AccountField;
